import { Stack } from "@mui/material";
import { useMemo } from "react";
import {
  ScrapEyesEventWithReviewData,
  useManualReviewEvents,
} from "../contexts/ManualReviewEventContext";
import { EventFlowItem } from "./EventFlowItem";

interface EventFlowDisplayProps {
  event: ScrapEyesEventWithReviewData;
}

export const EventFlowDisplay = ({ event }: EventFlowDisplayProps) => {
  const { allEvents } = useManualReviewEvents();

  const pairedEvent = useMemo(() => {
    if (!event.pairId) return undefined;
    return allEvents.find(
      (e) => e.pairId === event.pairId && e.id !== event.id
    );
  }, [event.pairId, event.id, allEvents]);

  const sortedEvents = useMemo(() => {
    if (pairedEvent) {
      return [event, pairedEvent].sort((a, b) => a.start.diff(b.start));
    }
    return [event];
  }, [event, pairedEvent]);

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {sortedEvents.map((e, idx) => (
        <EventFlowItem
          key={e.id}
          event={e}
          isCurrent={e.id === event.id}
          showArrow={idx > 0}
        />
      ))}
    </Stack>
  );
};
